import React, { useState } from 'react';

const DelUserData = () => {
    const [showInstructions, setShowInstructions] = useState(false);

    const handleDeleteData = () => {
        // Logic to delete app data goes here
        // You can use Facebook API or any other method to delete the data
        // Once the data is deleted, you can show a success message or redirect the user
    };

    return (
        <div>
            <h1>App Data Deletion</h1>
            <p>
                By clicking the button below, you will delete all your app data associated with this app.
                This action cannot be undone. Are you sure you want to proceed?
            </p>
            <button onClick={() => setShowInstructions(true)}>Delete App Data</button>

            {showInstructions && (
                <div>
                    <h2>Instructions:</h2>
                    <ol>
                        <li>Step 1: Open the app on your device.</li>
                        <li>Step 2: Go to the Settings menu.</li>
                        <li>Step 3: Find the Apps &amp; Websites section.</li>
                        <li>Step 4: Locate this app and click on it.</li>
                        <li>Step 5: Click on the Delete Data button.</li>
                        <li>Step 6: Confirm the deletion.</li>
                    </ol>
                    <button onClick={handleDeleteData}>I have deleted the data</button>
                </div>
            )}
        </div>
    );
};

export {DelUserData};